import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  Typography,
  Button,
  IconButton,
  Grid,
  MenuItem,
  TextField,
  Box,
  Switch,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import _ from "lodash";
import { useFormik } from "formik";
import * as yup from "yup";
import dayjs from "dayjs";
import { CUSTOM_CONSTANTS } from "Constants";

// Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

// Services
import servicefaretypeapi from "Services/ZoneServicefare";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ServiceUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);
  const [addedzone, setaddedzone] = useState([]);
  const [addedservicetype, setaddedservicetype] = useState([]);

  // Fetch servicefare Details
  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDetails(res?.data?.data);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    servicefaretypeapi.getzoneServicefarebyid(id).then(onSuccess, onFailure);
  }, [id, dispatch]);

  // Get Services list api
  const getServicetype = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setaddedzone(res?.data?.data?.data?.addedzone || []);
        setaddedservicetype(res?.data?.data?.data?.services || []);
      } else {
        setaddedzone([]);
        setaddedservicetype([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    servicefaretypeapi.getexcludedzoneServicesList().then(onSuccess, onFailure);
  }, [dispatch]);

  useEffect(() => {
    openDialog && getDetails();
    openDialog && getServicetype();
  }, [openDialog, getDetails, getServicetype]);

  const formatTime = (time) => {
    if (time && dayjs.isDayjs(time)) {
      return time.format("hh:mm:ss A");
    }
    return null;
  };

  const handleUpdateServicetype = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const payload = {
      ...formValues,
      Daystartingtime: formValues.daystartingtime ? formatTime(formValues.daystartingtime) : null,
      Nightstartingtime: formValues.nightstartingtime ? formatTime(formValues.nightstartingtime) : null,
      Dayendingtime: formValues.dayendingtime ? formatTime(formValues.dayendingtime) : null,
      Nightendingtime: formValues.nightendingtime ? formatTime(formValues.nightendingtime) : null,
      DaystartingtimeWeekend: formValues.daystartingtimeWeekend ? formatTime(formValues.daystartingtimeWeekend) : null,
      NightstartingtimeWeekend: formValues.nightstartingtimeWeekend ? formatTime(formValues.nightstartingtimeWeekend) : null,
      DayendingtimeWeekend: formValues.dayendingtimeWeekend ? formatTime(formValues.dayendingtimeWeekend) : null,
      NightendingtimeWeekend: formValues.nightendingtimeWeekend ? formatTime(formValues.nightendingtimeWeekend) : null,
      dayRange: "MONDAY-SUNDAY",
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Service fare Details Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to update data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    servicefaretypeapi.updatezoneServicefare(id, payload).then(onSuccess, onFailure);
  };

  const timeToString = (time) => {
    if (!time || typeof time !== "object") return "";
    const hour = time.hour.toString().padStart(2, "0");
    const minutes = time.minutes.toString().padStart(2, "0");
    return `${hour}:${minutes} ${time.Median}`;
  };

  const timeToDayjs = (time) => {
    if (!time) return null;
    const timeString = timeToString(time);
    return dayjs(timeString, "hh:mm A");
  };

  // Populate form values from fetched details
  useEffect(() => {
    if (!_.isEmpty(details)) {
      formik.setFieldValue("servicetypes", details?.zoneserviceTypeId?._id || "");
      formik.setFieldValue("daystartingtime", timeToDayjs(details?.daytime?.startingTime));
      formik.setFieldValue("nightstartingtime", timeToDayjs(details?.nighttime?.startingTime));
      formik.setFieldValue("dayendingtime", timeToDayjs(details?.daytime?.endingTime));
      formik.setFieldValue("nightendingtime", timeToDayjs(details?.nighttime?.endingTime));
      formik.setFieldValue("daybaseprice", details?.daytime?.basePrice || "");
      formik.setFieldValue("nightbaseprice", details?.nighttime?.basePrice || "");

      formik.setFieldValue("daystartingtimeWeekend", timeToDayjs(details?.daytimeWeekend?.startingTime));
      formik.setFieldValue("nightstartingtimeWeekend", timeToDayjs(details?.nighttimeWeekend?.startingTime));
      formik.setFieldValue("dayendingtimeWeekend", timeToDayjs(details?.daytimeWeekend?.endingTime));
      formik.setFieldValue("nightendingtimeWeekend", timeToDayjs(details?.nighttimeWeekend?.endingTime));
      formik.setFieldValue("daybasepriceWeekend", details?.daytimeWeekend?.basePrice || "");
      formik.setFieldValue("nightbasepriceWeekend", details?.nighttimeWeekend?.basePrice || "");

      formik.setFieldValue("ReverseLocation", details?.ReverseLocation ?? false);
      formik.setFieldValue("DestinationAddress", details?.DestinationAddress?._id || "");
      formik.setFieldValue("SourceAddress", details?.SourceAddress?._id || "");
    }
  }, [details]);

  const formik = useFormik({
    initialValues: {
      servicetypes: "",
      SourceAddress: "",
      DestinationAddress: "",
      ReverseLocation: false,
      daystartingtime: null,
      nightstartingtime: null,
      dayendingtime: null,
      nightendingtime: null,
      daystartingtimeWeekend: null,
      nightstartingtimeWeekend: null,
      dayendingtimeWeekend: null,
      nightendingtimeWeekend: null,
      daybaseprice: "",
      nightbaseprice: "",
      daybasepriceWeekend: "",
      nightbasepriceWeekend: "",
    },
    validationSchema: yup.object({
      servicetypes: yup.string().required("Service type is required").nullable(),
      SourceAddress: yup.string().required("Source Address is required").nullable(),
      DestinationAddress: yup.string().required("Destination Address is required").nullable(),
      daystartingtime: yup.string().required("Day starting time is required").nullable(),
      nightstartingtime: yup.string().required("Night starting time is required").nullable(),
      dayendingtime: yup.string().required("Day ending time is required").nullable(),
      nightendingtime: yup.string().required("Night ending time is required").nullable(),
      daystartingtimeWeekend: yup.string().required("Day starting time is required").nullable(),
      nightstartingtimeWeekend: yup.string().required("Night starting time is required").nullable(),
      dayendingtimeWeekend: yup.string().required("Day ending time is required").nullable(),
      nightendingtimeWeekend: yup.string().required("Night ending time is required").nullable(),
      daybaseprice: yup.number().typeError("Must be a number").required("Required"),
      nightbaseprice: yup.number().typeError("Must be a number").required("Required"),
      daybasepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      nightbasepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
    }),
    enableReinitialize: true,
    onSubmit: handleUpdateServicetype,
  });

  const renderTimePicker = (name, value) => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        ampm={true}
        value={value}
        onChange={(newValue) => formik.setFieldValue(name, newValue)}
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            variant: "outlined",
            className: classes.inputShape,
            error: Boolean(formik?.errors?.[name] && formik?.touched?.[name]),
            helperText: formik?.touched?.[name] && formik?.errors?.[name],
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            fullWidth
            variant="outlined"
            className={classes.inputShape}
            error={Boolean(formik?.errors?.[name] && formik?.touched?.[name])}
            helperText={formik?.touched?.[name] && formik?.errors?.[name]}
          />
        )}
      />
    </LocalizationProvider>
  );

  const renderTextField = (name, placeholder = "0.00") => (
    <TextField
      name={name}
      id={name}
      placeholder={placeholder}
      value={formik?.values?.[name]}
      onChange={formik.handleChange}
      error={Boolean(formik?.errors?.[name] && formik?.touched?.[name])}
      helperText={formik?.touched?.[name] && formik?.errors?.[name]}
      fullWidth
      variant="outlined"
      size="small"
      className={classes.inputShape}
    />
  );

  const handleModalClose = () => {
    formik.resetForm();
    handleClose();
  };

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleModalClose}
      maxWidth="lg"
      className={classes.root}
    >
      {/* Header */}
      <DialogTitle className={classes.dialogTitle}>
        <Typography className={classes.titleText}>Update zone Fare model</Typography>
        <IconButton aria-label="close" onClick={handleModalClose} className={classes.closeButton}>
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        {/* Location Selection Controls */}
        <Grid container spacing={2} style={{ marginBottom: 20 }}>
          <Grid item xs={12} sm={3}>
            <Typography className={classes.fieldLabel}>Source Address</Typography>
            <TextField
              name="SourceAddress"
              id="SourceAddress"
              select
              value={formik?.values?.SourceAddress}
              onChange={formik.handleChange}
              error={Boolean(formik?.errors?.SourceAddress && formik?.touched?.SourceAddress)}
              helperText={formik?.touched?.SourceAddress && formik?.errors?.SourceAddress}
              fullWidth
              variant="outlined"
              size="small"
              className={classes.inputShape}
            >
              {addedzone.map((service) => (
                <MenuItem key={service._id} value={service._id} style={{ fontSize: 12 }}>
                  {service.locationName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography className={classes.fieldLabel}>Destination Address</Typography>
            <TextField
              name="DestinationAddress"
              id="DestinationAddress"
              select
              value={formik?.values?.DestinationAddress}
              onChange={formik.handleChange}
              error={Boolean(formik?.errors?.DestinationAddress && formik?.touched?.DestinationAddress)}
              helperText={formik?.touched?.DestinationAddress && formik?.errors?.DestinationAddress}
              fullWidth
              variant="outlined"
              size="small"
              className={classes.inputShape}
            >
              {addedzone.map((service) => (
                <MenuItem key={service._id} value={service._id} style={{ fontSize: 12 }}>
                  {service.locationName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography className={classes.fieldLabel}>Service Type</Typography>
            <TextField
              name="servicetypes"
              id="servicetypes"
              select
              value={formik?.values?.servicetypes}
              onChange={formik.handleChange}
              error={Boolean(formik?.errors?.servicetypes && formik?.touched?.servicetypes)}
              helperText={formik?.touched?.servicetypes && formik?.errors?.servicetypes}
              fullWidth
              variant="outlined"
              size="small"
              className={classes.inputShape}
            >
              {addedservicetype.map((service) => (
                <MenuItem key={service.serviceName} value={service._id} style={{ fontSize: 12 }}>
                  {service.serviceName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={3} style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
            <Typography className={classes.fieldLabel}>Reverse Location</Typography>
            <Box style={{ display: "flex", alignItems: "center", height: 32 }}>
              <Switch
                name="ReverseLocation"
                id="ReverseLocation"
                checked={formik?.values?.ReverseLocation || false}
                onChange={(event) => formik.setFieldValue("ReverseLocation", event.target.checked)}
                sx={{
                  '& .MuiSwitch-switchBase': {
                    // Styles when UNCHECKED (Error state)
                    color: 'error.main',
                    '& + .MuiSwitch-track': {
                      backgroundColor: 'error.main',
                      opacity: 0.3,
                    },
                    // Styles when CHECKED (Success state)
                    '&.Mui-checked': {
                      color: 'success.main',
                      '& + .MuiSwitch-track': {
                        backgroundColor: 'success.main',
                        opacity: 0.5,
                      },
                    },
                  },
                }}
                size="small"
              />
              <Typography variant="body2" style={{ fontSize: 12, marginLeft: 4 }}>
                {formik?.values?.ReverseLocation ? "Yes" : "No"}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Tariff Columns (Side-by-Side) */}
        <Grid container spacing={2.5}>
          {/* MONDAY - THURSDAY TARIFF */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.sectionTitleHeader}>
              <b>MONDAY - THURSDAY TARIFF</b>
            </Typography>
            <Box className={classes.sectionHeaderDivider} />

            <Box className={classes.subHeaderRow}>
              <Typography className={classes.subHeaderText}>DAY TIME SETTINGS</Typography>
              <Typography className={classes.subHeaderText}>NIGHT TIME SETTINGS</Typography>
            </Box>

            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Starting Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("daystartingtime", formik.values.daystartingtime)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightstartingtime", formik.values.nightstartingtime)}</Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Ending Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("dayendingtime", formik.values.dayendingtime)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightendingtime", formik.values.nightendingtime)}</Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("daybaseprice")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightbaseprice")}</Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* FRIDAY - SUNDAY TARIFF */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.sectionTitleHeader}>
              <b>FRIDAY - SUNDAY TARIFF</b>
            </Typography>
            <Box className={classes.sectionHeaderDivider} />

            <Box className={classes.subHeaderRow}>
              <Typography className={classes.subHeaderText}>DAY TIME SETTINGS</Typography>
              <Typography className={classes.subHeaderText}>NIGHT TIME SETTINGS</Typography>
            </Box>

            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Starting Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("daystartingtimeWeekend", formik.values.daystartingtimeWeekend)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightstartingtimeWeekend", formik.values.nightstartingtimeWeekend)}</Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Ending Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("dayendingtimeWeekend", formik.values.dayendingtimeWeekend)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightendingtimeWeekend", formik.values.nightendingtimeWeekend)}</Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("daybasepriceWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightbasepriceWeekend")}</Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Bottom Action Buttons */}
          <Grid item xs={12}>
            <Box className={classes.actionButtonsContainer}>
              <Button
                variant="outlined"
                className={classes.closeButtonAction}
                onClick={handleModalClose}
              >
                Close
              </Button>
              <Button
                variant="contained"
                className={classes.submitButtonAction}
                onClick={formik?.handleSubmit}
              >
                Update Zone Fare model
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ServiceUpdate;
